import {
  Component,
  EventEmitter,
  ViewChild
} from '@angular/core';

import { Subject } from 'rxjs/Subject';

import { SkyDatepickerCalendarComponent } from './datepicker-calendar.component';

import {
  SkyDropdownComponent,
  SkyDropdownMessage,
  SkyDropdownMessageType
} from '../dropdown';


export class SkyDatepickerComponent {
  
  public calendar: SkyDatepickerCalendarComponent;

  
  public dropdown: SkyDropdownComponent;

  public dropdownController = new Subject<SkyDropdownMessage>();
  public dateChanged: EventEmitter<Date> = new EventEmitter<Date>();
  public maxDate: Date;
  public minDate: Date;

  public dateSelected(newDate: Date) {
    this.dateChanged.emit(newDate);
    this.dropdownController.next({
      type: SkyDropdownMessageType.Close
    });
  }

  public setSelectedDate(newDate: Date) {
    this.calendar.writeValue(newDate);
  }

  public setMinDate(_minDate: Date) {
    this.minDate = _minDate;
  }

  public setMaxDate(_maxDate: Date) {
    this.maxDate = _maxDate;
  }

  public onCalendarModeChange() {
    this.dropdownController.next({
      type: SkyDropdownMessageType.Reposition
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-datepicker',
  template: `<div class="sky-datepicker">
  <div class="sky-input-group">
    <ng-content></ng-content>

    <div class="sky-input-group-btn sky-input-group-datepicker-btn">
      <sky-dropdown
        buttonType="calendar"
        alignment="right"
        [messageStream]="dropdownController">
        <sky-dropdown-menu>
          <sky-datepicker-calendar
            (selectedDateChange)="dateSelected($event)"
            (calendarModeChange)="onCalendarModeChange()"
            [maxDate]="maxDate"
            [minDate]="minDate">
          </sky-datepicker-calendar>
        </sky-dropdown-menu>
      </sky-dropdown>
    </div>
  </div>
</div>
`,
  styles: [`.sky-input-group-datepicker-btn /deep/ .sky-dropdown-button.sky-btn {
  border-radius: 0;
  border-left-color: transparent;
}

.sky-input-group-datepicker-btn /deep/ .sky-dropdown-button.sky-btn:hover {
  border-left: 1px solid #cdcfd2;
}

.sky-input-group-datepicker-btn /deep/ .sky-dropdown-menu {
  box-shadow: none;
  background-color: transparent;
  text-align: center;
}

.sky-datepicker ::ng-deep .sky-popover-container .sky-popover {
  box-shadow: none;
  background-color: transparent;
}
`]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'calendar': [{ type: ViewChild, args: [SkyDatepickerCalendarComponent, ] },],
'dropdown': [{ type: ViewChild, args: [SkyDropdownComponent, ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
